import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';

const getIrregularityCategories = state => state.statics.irregularityCategories;
const getTcEvent = state => state.tcEvent.currentEvent;
const getTcEventRegs = state => state.irregularities.tcEventRegs;
const getRoomRegs = state => state.irregularities.roomRegs;
const getEventIrregularities = state => state.irregularities.eventIrregularities;

export const getCategoriesFilteredTypes = createSelector(
  [getIrregularityCategories, getTcEvent],
  (irregularityCategories, tcEvent) => {
    if (!irregularityCategories.length || !tcEvent || isEmpty(tcEvent)){
      return [];
    }

    let newCategories = irregularityCategories;
    newCategories.forEach((category) => {
      const types = category.irregularityTypes;
      category.irregularityTypes = types.filter(type => type.cycleId === tcEvent.testingEvent.adminId.cycleId.id)
    });
    return newCategories.filter(categ => !!categ.irregularityTypes.length);
  }
);

export const mapTcEventRegsOptions = createSelector(
  [getTcEventRegs],
  (tcEventRegs) => {
    return tcEventRegs.map(reg => ({
      label: `${reg.lastName}, ${reg.firstName} ${reg.middleName}`,
      value: reg.id,

    }));
  }
);

export const mapRoomRegsOptions = createSelector(
  [getRoomRegs],
  (roomRegs) => {
    return roomRegs.map(reg => ({
      label: `${reg.lastName}, ${reg.firstName} ${reg.middleName}`,
      value: reg.id,
    }));
  }
);

export const getSubmittedIrregularities = createSelector(
  [getEventIrregularities],
  (irregularities) =>
    irregularities && irregularities.length ?  irregularities.filter(irreg => !irreg.reviewCompleteFlag) : []
);